import { useNavigate, useParams } from 'react-router-dom';
import { ResourceInterface } from '../../../domain/interface/resource_interface';
import ResourceItem from './resource_item';
import { useCallback, useMemo } from 'react';
import { useTranslation } from '../../../../../i18n/useTranslation';

interface CategoryProps {
  title: string;
  color: string;
  resources: ResourceInterface[];
  path: string;
  showMore: boolean;
}

const ResourceCategory: React.FC<CategoryProps> = ({
  title,
  color,
  resources,
  path,
  showMore,
}) => {
  const { t } = useTranslation();
  const { themeId } = useParams();
  const navigate = useNavigate();

  const handleSeeAll = useCallback(() => {
    console.log("new path: ", `/career/${themeId}/resources/${path}`);
    navigate(`/career/${themeId}/resources/${path}`);
  }, [themeId, path, navigate]);

  const sortedResources = useMemo(() => {
    return resources.sort((a, b) => {
      if (a.viewed === b.viewed) {
        return 0;
      }
      return a.viewed ? 1 : -1;
    });
  }, [resources]);

  return (
    <div className="flex flex-col gap-2.5 w-full">
      <div className="flex justify-between items-center max-lg:px-[3%] lg:px-[1%]">
        <h2 className="text-xl font-bold leading-tight" style={{ color }}>
          {title}
        </h2>
        {showMore && <button
          className="text-xs font-light cursor-pointer"
          style={{ color: color }}
          onClick={handleSeeAll}
        >
          {t('common.button.see_all')}
        </button>}
      </div>
      <div className="w-full overflow-x-auto home-scrollbar">
        <div data-resource-track className="flex gap-3 max-lg:px-[3%] lg:px-[1%] pb-3.75 w-max">
          {sortedResources.map((resource) => (
            <ResourceItem
              key={resource._id}
              id={resource._id}
              title={resource.title}
              pictureUrl={resource.picture}
              viewed={resource.viewed}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ResourceCategory;
